import React, {Component} from "react";
import TopTourneys from "./components/TopTourneys";
import EventFilter from "./components/EventFilter";
import LeftMenu from "./components/LeftMenu";

class LeftSide extends Component {
	render() {
		return (
			<div className="body__container__side-left">
				{/*<TopTourneys/>*/}

				<EventFilter/>

				<LeftMenu/>
			</div>
		);
	}
}

export default LeftSide;


// WEBPACK FOOTER //
// ./src/app/LeftSide.js